import { Type, type Static } from "@sinclair/typebox";

export const AssetInstallmentSaveSchema = Type.Object(
  {
    operationId: Type.String({ format: "uuid" }),
    version: Type.Integer({ minimum: 1 }),
    firstMonth: Type.String({
      pattern: "^(20[0-9]{2}|21[0-9]{2}|2200)-(0[1-9]|1[0-2])$",
    }),
    installmentCount: Type.Integer({ minimum: 1, maximum: 600 }),
    installmentAmount: Type.Number({ minimum: 0.01, maximum: 999999999.99 }),
  },
  { additionalProperties: false },
);
export type AssetInstallmentSave = Static<typeof AssetInstallmentSaveSchema>;
export interface AssetInstallmentTerms {
  firstMonth: string;
  installmentCount: number;
  /** Full management cost per monthly installment, including financing interest. */
  installmentAmount: number;
}
export interface AssetInstallmentScheduleRow {
  number: number;
  month: string;
  amount: string;
  accrued: boolean;
}
export interface AssetInstallmentSummary {
  firstMonth: string;
  lastMonth: string;
  installmentCount: number;
  installmentAmount: string;
  totalAmount: string;
  annualAmount: string;
  accruedAnnualAmount: string;
  currentMonthlyAmount: string;
  remainingInstallments: number;
  status: "scheduled" | "active" | "completed";
  managementYear: number;
  asOfMonth: string;
  months: AssetInstallmentScheduleRow[];
}
export interface AssetInstallmentPlan extends AssetInstallmentSummary {
  version: number;
}
